import React from "react";
import DataTablePage from "@/components/common/DataTablePage";

export default function SeoPage() {
  return (
    <DataTablePage
      collection="seo_items"
      eyebrow="Organic Growth"
      title="SEO Planner"
      subtitle="Track high-intent keywords, collection pages and blog content. Optimize titles, meta, alt text and schema over time."
      emptyDefault={{ type: "Collection", intent: "High", status: "todo" }}
      columns={[
        { key: "keyword", label: "Keyword / Topic", type: "text" },
        { key: "type", label: "Type", type: "select", options: ["Collection", "Blog", "On-page"] },
        { key: "target_url", label: "Target URL", type: "text" },
        { key: "intent", label: "Intent", type: "select", options: ["High", "Medium", "Low"] },
        { key: "status", label: "Status", type: "badge", options: ["todo", "in_progress", "done"] },
        { key: "notes", label: "Notes", type: "textarea" },
      ]}
    />
  );
}
